export const useCurrentHeaderHeight = (): number => {
    return document.getElementsByClassName("header-wrapper")[0].clientHeight;
};
